(function () {
    "use strict";

    angular.module("iMatApp")
        .component("modelViewer", modelViewerComponent());

    function modelViewerComponent() {
        return {
            bindings: {
                previewInfo: '<',
                file: '<',
                renderingData: '<',
                options: '<',
                onError: '&'
            },
            templateUrl: '/Scripts/iMatApp/views/modelViewerTemplate.html',

            controller: ModelViewerComponentController,
            controllerAs: "modelViewerViewModel"
        };
    }

    ModelViewerComponentController.$inject = ['$scope', '$element', '$window', 'modelViewerService', 'eventService'];

    function ModelViewerComponentController($scope, $element, $window, modelViewerService, eventService) {
        var vm = this;
        var containerElement = $element.find(".three-d-viewer-canvas");

        vm.stripeUrl = angular.undefined;
        vm.isRenderViewFailed = false;
        vm.isPreloaderVisible = true;

        vm.getViewName = getViewName;
        vm.noPreviewCanBeShown = noPreviewCanBeShown;
        vm.stripeLoaded = stripeLoaded;
        vm.loadStripeFailed = loadStripeFailed;

        // it will be called once all bindings are initialized
        this.$onInit = activate;
        this.$onChanges = bindingsChanged;

        eventService.subscribe($scope, 'viewerInit', onViewerInit);
        eventService.subscribe($scope, 'viewerDestroy', onViewerDestroy);
        // -----------------------------------------------------------------------------------
        function activate() {
        }

        function getViewName() {
            if (vm.isPreloaderVisible) {
                return 'Preloader';
            }

            if (vm.noPreviewCanBeShown()) {
                return 'NoPreview';
            }

            if (vm.stripeUrl) {
                return '2D';
            }

            return '3D';
        }

        function bindingsChanged(changes) {
            if (changes.previewInfo) {
                show3DModelByUrl(changes.previewInfo.currentValue, changes.previewInfo.previousValue);
            }

            if (changes.file) {
                show3DModelByFile(changes.file.currentValue, changes.file.previousValue);
            }

            if (changes.renderingData) {
                updateRenderingData(changes.renderingData.currentValue, changes.renderingData.previousValue);
            }

            if (changes.options) {
                updateOptions(changes.options.currentValue);
            }
        }

        function stripeLoaded() {
            vm.isRenderViewFailed = false;
            hidePreloader();
        }

        function loadStripeFailed($event) {
            vm.isRenderViewFailed = true;
            hidePreloader();

            vm.onError({ $event: $event });
        }

        function noPreviewCanBeShown() {
            if (!hasData()) {
                return false;
            }

            var result = !hasPreview() || vm.isRenderViewFailed;
            return result;
        }

        // -----------------------------------------------------------------------------------

        function show3DModelByUrl(preview, oldPreview) {
            if (angular.isUndefined(preview) || angular.equals(preview, oldPreview)) {
                return;
            }

            // Still show direct shown model
            if (preview === null && vm.file) {
                return;
            }

            modelViewerService.destroy();

            if (preview === null) {
                hidePreloader();
                return;
            }

            showPreloader();

            vm.isRenderViewFailed = false;
            if (modelViewerService.canBeShownBy3DViewer(preview)) {
                vm.stripeUrl = angular.undefined;

                modelViewerService.initViewer($scope, containerElement);
                var showPromise = modelViewerService.showModelByUrl(preview.url);

                handleModelShown(showPromise);

            } else {
                modelViewerService.abort();
                vm.stripeUrl = preview.url;
            }
        }

        function show3DModelByFile(newFile, oldFile) {
            if (!angular.isObject(newFile) || angular.equals(newFile, oldFile)) {
                return;
            }

            modelViewerService.destroy();

            if (newFile === null) {
                hidePreloader();
                return;
            }

            vm.isRenderViewFailed = false;

            if (modelViewerService.canBeShowDirectly(newFile)) {
                vm.stripeUrl = angular.undefined;
                showPreloader();

                modelViewerService.initViewer($scope, containerElement);
                var showPromise = modelViewerService.showModelByFile(newFile);

                handleModelShown(showPromise);

            } else {
                vm.isRenderViewFailed = true;
                vm.onError({ $event: reason });
            }
        }

        function handleModelShown(promise) {
            promise
                .then(function () {
                    updateRenderingData(vm.renderingData);
                    updateOptions(vm.options);

                    vm.isRenderViewFailed = false;
                })
                .catch(function (reason) {
                    if (reason === "CANCELED") {
                        vm.isRenderViewFailed = false;
                        return;
                    }

                    vm.isRenderViewFailed = true;
                    vm.onError({ $event: reason });
                })
                .finally(function () {
                    hidePreloader();
                });
        }

        function updateRenderingData(newValue, oldValue) {
            if (angular.equals(newValue, oldValue)) {
                return;
            }

            if (angular.isUndefined(newValue) || newValue === null) {
                modelViewerService.useDefaultRenderingData();
            } else {
                modelViewerService.setRenderingData(newValue);
            }
        }

        function updateOptions(newOptions) {
            if (newOptions && angular.isDefined(newOptions.groundPlane)) {
                modelViewerService.groundPlaneEnabled(newOptions.groundPlane);
            }

            if (newOptions && angular.isDefined(newOptions.clipping)) {
                modelViewerService.clippingEnabled(newOptions.clipping);
            }

            if (newOptions && angular.isDefined(newOptions.autoRotate)) {
                modelViewerService.autoRotateEnabled(newOptions.autoRotate);
            }

            if (newOptions && angular.isObject(newOptions.cameraPosition)) {
                modelViewerService.setCameraPosition(newOptions.cameraPosition);
            }
        }

        function hasData() {
            // null can be as value. It's mean no preview will be shown when null is set.
            return angular.isDefined(vm.previewInfo) || angular.isDefined(vm.file);
        };

        function hasPreview() {
            return angular.isObject(vm.previewInfo) || angular.isObject(vm.file);
        };

        function showPreloader() {
            vm.isPreloaderVisible = true;
        }

        function hidePreloader() {
            vm.isPreloaderVisible = false;
        }

        function onViewerInit() {
            addEventListeners()
        }

        function onViewerDestroy() {
            removeEventListeners();
        }

        function addEventListeners() {
            angular.element(containerElement).on("dblclick.modelviewer", onDoubleClick);
            angular.element($window).on("resize.modelViewer", onResize);
        }

        function removeEventListeners() {
            angular.element(containerElement).off("dblclick.modelviewer");
            angular.element($window).off("resize.modelViewer");
        }

        function onDoubleClick() {
            modelViewerService.toggleAutoRotate();
        }

        function onResize() {
            modelViewerService.resize();
        }

    }
})();